import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

import { AllComponents } from "@/builder/client/AllComponents";
import { FieldStyle, PageType, PartialDisplayType } from "@/builder/enums";
import { PageDesign } from '@/builder/interfaces';
import { useRenderStore } from "@/builder/stores/renderStore";
import StretchyDots from "@/components/shared/animation/StretchyDots.vue";
import TestModeBanner from '@/components/shared/banner/TestModeBanner.vue';
import { computed, defineAsyncComponent, inject, nextTick, onBeforeMount, onMounted, provide, ref, watch } from "vue";
import { publicApiService } from "../../services/publicApiService";
import ErrorContainer from "../components/shared/ErrorContainer.vue";

//asyc components

export default /*@__PURE__*/_defineComponent({
  __name: 'ClientApp',
  props: {
    pageId: {},
    organizationId: {},
    environment: {}
  },
  setup(__props: any) {

const CookieConsent = defineAsyncComponent(() => import("../../components/shared/cookie/CookieConsent.vue"));

// props
const props = __props;

if (props.environment === "local") {
    //delete the div tag with id #app to avoid odd spacing when testing locally
    const appDiv = document.getElementById("app");
    if (appDiv) {
        appDiv.remove();
    }
}

// inject
const renderStore = useRenderStore();
const publicApi = inject('publicApiService') as publicApiService;

const pageDesign = ref(renderStore.page.pageDesign ?? {
    fieldStyle: FieldStyle.Default
} as PageDesign);

const showCookieConsent = ref(false);

const updatePageDesign = (newVal: PageDesign) => {
    pageDesign.value = newVal;
}

provide("pageDesign", pageDesign);

// refs
const organizationId = ref(Number.parseInt(props.organizationId));

// computed
const isEmbed = computed(() => renderStore.page.pageType !== PageType.Full);
const getRaiseDonorsClass = computed(() => {
    return isEmbed.value ? "raise-donors raise-donors-embed" : "raise-donors";
});

// lifecycle
onBeforeMount(async () => {
    renderStore.loadOrganization(organizationId.value);
    await renderStore.load(props.pageId, organizationId.value);
    updatePageDesign(renderStore.page.pageDesign);
});

onMounted(async () => {
    // @ts-ignore
    if (window.zE) {
        // @ts-ignore
        window.zE("webWidget", "hide");
    }

    // If user is using tracking pixel, get visitor giving
    if (renderStore.page.useTrackingPixel) {
        try {
            renderStore.visitorGiving = await publicApi.findVisitor(organizationId.value);
        } catch (error) {
            renderStore.visitorGiving = null;
        }
    }
});

// watch
watch(() => renderStore.cookieAcceptance, (newVal) => {
    //wait for next tick to show cookie consent so we do not show it before properly set
    nextTick(() => {
        if (newVal) {
            showCookieConsent.value = !newVal.accepted;
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (isEmbed.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "raise-donors",
        class: _normalizeClass(getRaiseDonorsClass.value)
      }, [
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(TestModeBanner, {
              key: 0,
              source: "public"
            }))
          : _createCommentVNode("", true),
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(ErrorContainer, { key: 1 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderStore).page.components, (component) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[component.type]), {
            key: component.id,
            component: component
          }, null, 8, ["component"]))
        }), 128)),
        (_unref(renderStore).isProcessing)
          ? (_openBlock(), _createBlock(StretchyDots, { key: 2 }))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("main", {
        key: 1,
        id: "raise-donors",
        class: _normalizeClass(getRaiseDonorsClass.value)
      }, [
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(TestModeBanner, {
              key: 0,
              source: "public"
            }))
          : _createCommentVNode("", true),
        (_unref(renderStore).page.partialDisplayType !== _unref(PartialDisplayType).Modal)
          ? (_openBlock(), _createBlock(ErrorContainer, { key: 1 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderStore).page.components, (component) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AllComponents)[component.type]), {
            key: component.id,
            component: component
          }, null, 8, ["component"]))
        }), 128)),
        (_unref(renderStore).isProcessing)
          ? (_openBlock(), _createBlock(StretchyDots, { key: 2 }))
          : _createCommentVNode("", true)
      ], 2))
}
}

})